<template>
    <div>
        <AvatarUploadModal />
    </div>
</template>

<script>
import AvatarUploadModal from '@/components/modals/AvatarUploadModal.vue';

export default {
    name: 'ProfileSetupModals',
    components: {
        AvatarUploadModal,
    },
};
</script>
